import { FC, PropsWithChildren, createContext, useContext } from 'react';
import noop from 'utils/noop';

export enum ElementType {
  Condition = 'Condition',
  Requirement = 'Requirement',
  Criteria = 'Criteria',
}

type ElementIndex = number;

type ElementIndexState = {
  [elementType: string]: {
    index: ElementIndex;
    removeCurrentElementFn?: () => void;
  };
};

const defaultState: ElementIndexState = {};

const ElementIndexContext = createContext(defaultState);

type ElementIndexContextProviderProps = {
  type: ElementType;
  index: number;
  removeCurrentElementFn?: () => void;
};

const useElementIndexContext = () => useContext(ElementIndexContext);

export const ElementIndexContextProvider: FC<
  PropsWithChildren<ElementIndexContextProviderProps>
> = ({ children, type, index, removeCurrentElementFn }) => {
  const parentIndexState = useElementIndexContext();
  const childIndexState: ElementIndexState = {
    ...parentIndexState,
    [type]: { index, removeCurrentElementFn },
  };
  return (
    <ElementIndexContext.Provider value={childIndexState}>{children}</ElementIndexContext.Provider>
  );
};

export const useElementIndex = (type: ElementType) => useElementIndexContext()[type]?.index ?? 0;

export const useRemoveCurrentElement = (type: ElementType) =>
  useElementIndexContext()[type]?.removeCurrentElementFn ?? noop;
